/**
 * Personalization Redux Reducer
 */

import {
  LOADING_PERSONALIZATION,
  LOADED_PERSONALIZATION,
  PERSONALIZATION_ERROR,
} from './personalization.types';

const initialState = {
  accountType: null,
  productType: [],
  country: null,
  public_user_id: null,
  loading: false,
  loaded: false,
  error: null
};

export default function personalizationReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_PERSONALIZATION:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LOADED_PERSONALIZATION: {
      const { account_type, product_type, country, public_user_id } = action.payload;
      return {
        ...state,
        accountType: account_type,
        productType: product_type || [],
        country,
        public_user_id,
        loading: false,
        loaded: true,
        error: null
      };
    }

    case PERSONALIZATION_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };

    default:
      return state;
  }
}
